import { clientWithApiClient } from "../../client";
import type { ApiClient, ListResponse } from "../../types";
import type { CheckoutScreeningQuestion, ScreeningQuestionFlow } from "./types";

const BASE_PATH = "/screening-questions/checkout";

/**
 * Public, checkout-facing read of a fleet's active booking-questions catalog
 * for one flow. Deliberately NOT the same literal path as the manager CRUD
 * surface (`../screening-questions`, `/screening-questions`): declaring the
 * same path again in this earlier-registered, more permissive scope would
 * silently shadow the manager route's `booking_questions_settings`
 * permission gate for every request, including JWT fleet-manager sessions.
 *
 * Reachable by API key (the embed widget) or JWT (the fleet app's own
 * checkout preview) — gated server-side by its own
 * `api_screening_questions_checkout_get` permission, not
 * `booking_questions_settings` (that one gates *configuring* the catalog,
 * not reading the live set a renter sees).
 */
export const screeningQuestionsCheckout = {
  get: async (client: ApiClient, flow: ScreeningQuestionFlow) =>
    clientWithApiClient<ListResponse<CheckoutScreeningQuestion>>(
      client,
      `${BASE_PATH}?flow=${encodeURIComponent(flow)}`,
    ),
};
